/// <reference path="../_all.ts" />


module menuEditor {
  'use strict';



	/**
	 * The main controller for the app. The controller:
	 * - retrieves and persists the model via the todoStorage service
	 * - exposes the model to the template and provides event handlers
	 */
  export class MenuEditorDetailCtrl {


    // $inject annotation.
    // it provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // see http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$mdDialog',
      'menueditorService',
      '$timeout',
      'CacheFactory'
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IMenuEditorDetailScope,
      private $mdDialog: ng.material.IDialogService,
      private menueditorService: menueditorService,
      private $timeout: ng.ITimeoutService,
      public CacheFactory: CacheFactory.ICacheFactory
    ) {

      $scope.vm = this;

      $scope.currentNavItem = 'Anwendungen';

      $scope.currentNavItem2 = 'Wasser';

      menueditorService.getBusinessAreaList().then((response: { data: BusinessArea[] }) => {
        $scope.businessAreaList = response.data;
        $scope.selectedMenu = 'Anwendungen';
        $scope.selectedBusinessArea = $scope.businessAreaList[0];
        $scope.selectedIndustry = $scope.selectedBusinessArea.Industries[0];
        $scope.selectedGroup = $scope.selectedBusinessArea.MeasuringTaskGroups[0];
        $scope.selectedTask = $scope.selectedGroup.MeasuringTasks[0];
      });


      $scope.$watch('selectedMenu', (oldVal: string, newVal: string) => {
        if (oldVal == newVal) return;
        if (oldVal == "Anwendungen") {
          this.$scope.selectedGroup = this.$scope.selectedBusinessArea.MeasuringTaskGroups[0];
        }
        if (oldVal == "Industrien") {
          this.$scope.selectedIndustry = this.$scope.selectedBusinessArea.Industries[0];
          this.$scope.selectedGroup = this.$scope.selectedIndustry.MeasuringTaskGroup[0];
        }
      })

      $scope.$watch('selectedBusinessArea', (oldVal: BusinessArea, newVal: BusinessArea) => {
        if (oldVal == newVal) return;
        if ($scope.currentNavItem == "Anwendungen") this.$scope.selectedGroup = this.$scope.selectedBusinessArea.MeasuringTaskGroups[0];
        if ($scope.currentNavItem == "Industrien") this.$scope.selectedIndustry = this.$scope.selectedBusinessArea.Industries[0];
      })

      $scope.$watch('selectedIndustry', (oldVal: Industry, newVal: Industry) => {
        if (oldVal == newVal) return;
        if ($scope.currentNavItem == "Industrien") this.$scope.selectedGroup = this.$scope.selectedIndustry.MeasuringTaskGroup[0];
      })

      $scope.$watch('selectedGroup', (oldVal: MeasuringTaskGroup, newVal: MeasuringTaskGroup) => {
        if (oldVal == newVal) return;
        this.$scope.selectedTask = this.$scope.selectedGroup.MeasuringTasks[0];
      })

    };

    setSelectedBA(area: BusinessArea) {
      this.$scope.selectedBusinessArea = area;
    }

    setSelectedMenu(menu: string) {
      this.$scope.selectedMenu = menu;
    }

    onHideGroup(item: MeasuringTaskGroup) {
      item.Modified = true;
      item.MeasuringTasks.forEach((mt: MeasuringTask) => {
        mt.IsHidden = item.IsHidden;
        mt.Modified = true;
        mt.Product.forEach((pr: Product) => {
          pr.IsHidden = item.IsHidden
          pr.Modified = true;
        })
      })
    }

    onHideIndustry(item: Industry) {
      item.Modified = true;
      item.MeasuringTaskGroup.forEach((mg: MeasuringTaskGroup) => {
        mg.IsHidden = item.IsHidden;
        mg.Modified = true;
        mg.MeasuringTasks.forEach((mt: MeasuringTask) => {
          mt.IsHidden = item.IsHidden;
          mt.Modified = true;
          mt.Product.forEach((pr: Product) => {
            pr.IsHidden = item.IsHidden;
            pr.Modified = true;
          })
        })
      })
    }

    onHideTask(item: MeasuringTask) {
        item.Modified = true;
        item.Product.forEach((pr: Product) => {
            pr.IsHidden = item.IsHidden;
            pr.Modified = true;
        })
    }

    onHideProduct(item) {
        item.Modified = true;
    }

    save() {
      var bas = this.$scope.businessAreaList;
      this.$scope.working = true;
      this.menueditorService.saveBusinessAreaList(bas).then((response: { data: BusinessArea[] }) => {
        this.CacheFactory.destroyAll();
        this.$scope.working = false;
        this.$scope.saved = true;
        this.$timeout(() => { this.$scope.saved = false; }, 2000);
      });
    };

    cancel() {
      this.$mdDialog.cancel();
    };
  }
}